import { table as rules } from "@app/domain";
import { useEffect, useState } from "react";
import { useT } from "../i18n/context";
import { targetLabel } from "../routes/lobbyText";
import { waitLabel } from "./matchWait";
import type { Search } from "./useMatch";

/**
 * "Finding players for Batak" while the queue works (review 0020 S4): how many wait, how long,
 * and the way out. The screen reader hears the count, not every passing second.
 */
export function Searching({ search, onStop }: { search: Search; onStop: () => void }) {
  const { t } = useT();
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1_000);
    return () => window.clearInterval(id);
  }, []);
  const game = t(`variant.${search.variant}`);
  return (
    <section
      aria-label={t("match.searching", { game })}
      className="flex flex-wrap items-center justify-between gap-3 rounded-[16px] border-[1.5px] border-success/60 bg-panel-strong px-4 py-3 shadow-glow-soft"
    >
      <div className="flex min-w-0 flex-col gap-0.5">
        <span role="status" className="text-[15px] font-extrabold">
          {t("match.searching", { game })}
        </span>
        <span className="text-[13px] text-ink/80">
          {search.unreachable
            ? t("match.unreachable")
            : t("match.waiting", {
                count: search.waiting,
                time: waitLabel(search.since, now, search.skew),
              })}
        </span>
        <span className="text-[12px] text-ink/80">
          {t("match.standard", {
            target: targetLabel(t, rules.standardSettings(search.variant)),
            tempo: t("tempo.normal"),
          })}
        </span>
        <span className="text-[12px] text-ink/65">{t("match.hint")}</span>
      </div>
      <button type="button" className="btn-glass h-10 rounded-pill px-4 font-bold" onClick={onStop}>
        {t("match.stop")}
      </button>
    </section>
  );
}
